jQuery(document).ready(function () {
    if (jQuery(window).width() > 767) {
        fl_stick_array = ["#masthead", "body"];
        fl_header_height = jQuery('header').outerHeight() - jQuery(".storefront-primary-navigation").outerHeight();
        fl_header_height < jQuery(this).scrollTop() ? (fl_sticky_classes(fl_stick_array, "add")) : (fl_sticky_classes(fl_stick_array, "remove"));

        jQuery(window).scroll(function () {
            fl_header_height < jQuery(this).scrollTop() ? (fl_sticky_classes(fl_stick_array, "add")) : (fl_sticky_classes(fl_stick_array, "remove"));
        });

        function fl_sticky_classes(fl_stick_array, todo) {
            for (var i = 0; i < fl_stick_array.length; i++) {
                if (todo === "add") {
                    jQuery(fl_stick_array[i]).addClass("stickyfl");
                    jQuery("body").attr("style", "padding-top: " + (fl_header_height + jQuery(".storefront-primary-navigation").outerHeight()) + "px");
                }
                if (todo === "remove") {
                    jQuery(fl_stick_array[i]).removeClass("stickyfl");
                    jQuery("body").attr("style", "padding-top: 0px");
                }
            }
        }
    }
});